module.exports = __webpack_public_path__ + "static/sampleImage-e3b7fb824456a44e0772e5b176a15786.png";